import { ControlAttributeType } from "../../../../form/typings";
import { formatterValueToSetStatus } from "../../../../form/utils";
export default {
    groups: {
        controller: {
            label: "控制属性",
            keys: ["heads", "tabDefaultValue"],
        },
    },
    properties: {
        // 显示条件
        heads: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/tabs-heads-setting.vue"),
            options: {
                formatter: formatterValueToSetStatus,
                exportModal: (data, attr, attrs, callback, vm) => {
                    let field = attr.attrType;
                    if (!!field) {
                        callback(field, data.default);
                    }
                    // 设置tab标签页默认选项的值
                    let source = attrs.find((a) => a.field === "heads");
                    let tabs = attrs.find((a) => a.field === "tabDefaultValue");
                    if (source && tabs) {
                        let keys = data.value.find((d) => d.key === tabs.value);
                        if (!keys) {
                            // tabs.value = "";
                            tabs.value = data.value[0].key;
                        }
                    }
                    // console.log("DATA: " + data.value);
                    vm.$emit("change", "tabDefaultValue", tabs.value);
                    return data && data.value ? data.value : "";
                }
            }
        },
        tabDefaultValue: {
            inputMethod: ControlAttributeType.Dropdown,
            value: "tab1",
            options: {
                allowClear: true,
                list: (attrs) => {
                    return attrs.options.heads.map((p) => {
                        return {
                            value: p.key,
                            label: p.title
                        };
                    });
                }
            }
        }
    },
};
